<template>
    <div>
        <el-tree v-if="show"
            :props="properties"
            :load="loadNode"
            node-key="id"
            ref="dialogtree"
            lazy
            highlight-current
            default-expanded-keys="{1}"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
            :render-content="renderContent">
        </el-tree>
    </div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data() {
      return {
        properties: {
            label: 'label',
            isLeaf: 'isLeaf'
        },
        show: true,
        loadingScreen: null,
        tagList: {},
        tenantList: []
      };
    },
    methods: {
    	handleNodeClick(data, node, elNode) {
            this.$emit('on-selectnode', data,elNode)
        },
        reload() {
            this.show = false;
            this.$nextTick(() => {
                 this.show = true
            })
        },
        loadNode(node, resolve) {
            let self = this;
            let targetObjectCount = 0;
            if (node.parent == null) {
                if (this.initialData.length > 0) {
                    resolve(this.initialData);
                }
                return;
            }

            if (node.data.connectedUser != null) {
                let data = [];
                data.push(node.data.connectedUser[0]);
                resolve(data);
                return;
            }

            this.loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Loading data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });

            server.post('/getchildren', {tenantId: node.data.tenantId, parentId: node.data.id, type: -1})   // node.data.tenantId , node.data.id
                .then((res) => {
                    if (res.data.status >= constants.STATUS_SUCCESS) {
                        let data = [];
                        for (let i = 0; i < res.data.nodeInfo.length; i++) {
                            data.push({
                                tenantId: node.data.tenantId,
                                id: res.data.nodeInfo[i].id,
                                label: res.data.nodeInfo[i].name,
                                type: res.data.nodeInfo[i].type,
                                isLeaf: res.data.nodeInfo[i].hasChild  == 0 ? true : false
                            });
                        }
                        if (this.selectionType == constants.OBJECT_USER) {
                            for (let i = 0; i < res.data.userInfos.length; i++) {
                                if (!self.showAdminUser &&
                                    res.data.userInfos[i].restrictions != null &&
                                    res.data.userInfos[i].restrictions.includes(constants.RESTRICTION_LOGIN)
                                ) {
                                    continue;
                                }

                                data.push({
                                    tenantId: node.data.tenantId,
                                    id: res.data.userInfos[i].userId,
                                    name: res.data.userInfos[i].userName,
                                    displayName: res.data.userInfos[i].displayName,
                                    label: res.data.userInfos[i].userName + " / " + res.data.userInfos[i].displayName,
                                    type: constants.OBJECT_USER,
                                    restrictions: res.data.userInfos[i].restrictions,
                                    isLeaf: true
                                });
                            }
                        }
                        if (this.selectionType == constants.OBJECT_TALKGROUP) {
                            for (let i = 0; i < res.data.talkGroupInfos.length; i++) {
                                data.push({
                                    tenantId: node.data.tenantId,
                                    id: res.data.talkGroupInfos[i].talkgroupId,
                                    label: res.data.talkGroupInfos[i].talkgroupName,
                                    type: constants.OBJECT_TALKGROUP,
                                    isLeaf: true
                                });
                            }
                        }
                        data.sort(function(e1, e2) {
                            if (e1.type < e2.type) return -1;
                            else if (e1.type > e2.type) return 1;
                            else {
                                let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                                if (comparisonResult < 0) return -1;
                                else if (comparisonResult > 0) return 1;
                            }
                            return 0;
                        });
                        resolve(data);
                        self.closeLoadingScreen();
                    } else {
                        switch(res.data.status) {
                            case -3:
                                if (node.data.tenantId != this.initialData[0].tenantId) {
                                    if (node.data.id == 1) {
                                        // disregards access denied error when get children of ROOT_NODE of other tenant.
                                    } else {
                                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_expand_layer_denied_link"));
                                    }
                                } else {
                                    commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_expand_layer_denied"));
                                }
                                break;
                            case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","loadNode").replace("{code}",res.data.status));
                                break;
                        }
                        node.loading = false;
                        node.isLeaf = true;
                        node.data.isLeaf = true;
                    }
                    self.closeLoadingScreen();
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "loadNode", error);
                    self.closeLoadingScreen();
                });
        },
        renderContent(h, { node, data, store }) {
            let objectIcon = "";
            switch (data.type) {
                case constants.OBJECT_NODE:
                    if (data.id == 1) {
                        objectIcon = require("../assets/icon_tenant.svg");
                    } else {
                        objectIcon = require("../assets/icon_level.svg");
                    }
                    break;
                case constants.OBJECT_USER:
                     if (data.restrictions != null &&
                         data.restrictions.includes(constants.RESTRICTION_LOGIN)
                     ) {
                        objectIcon = require("../assets/admin_user.svg");
                    } else {
                        objectIcon = require("../assets/user.svg");
                    }
                    break;
                case constants.OBJECT_TALKGROUP:
                    objectIcon = require("../assets/group.svg");
                    break;
            }

            return h("span", { style: { display: "flex" } }, [h("img", { attrs: { src: objectIcon ,height: "20px" , style: "vertical-align: middle" } }), h("span",node.label)]);
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        }
    },
    created: function() {
    },
    props: {
        initialData: Object,
        selectionType: Number,
        showAdminUser: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #ecf1fa !important;
}
.el-tree-node__content:hover {
    background-color: transparent !important;
}
.el-tree-node__content {
    height: 40px !important;
}
</style>

